import * as React from 'react';
import cn from 'classnames';
import { Global } from '@weddingspot/ws-core-components';
import { Button } from '@cvent/carina/components/Button';

const _styles = require('./FilterInterstitial.scss');

interface InterstitialProps {
    visible: boolean;
    title: string;
    close: () => void;
    clear?: (e: React.SyntheticEvent) => void;
    filterClassName?: string;
    headerClassName?: string;
    bodyClassName?: string;
    footerClassName?: string;
    hideSecondaryDismiss?: boolean;
}

const FilterInterstitial = (props: React.PropsWithChildren<InterstitialProps>) => {
    const handleClose = () => {
        props.close();
    };

    return (
        <div className={cn(_styles.container, props.filterClassName, { [_styles.containerHidden]: !props.visible })}>
            {props.visible && <Global preventScrolling='onlyMobile' />}
            <div className={cn(_styles.header, props.headerClassName)}>
                <div className={_styles.title}>{props.title}</div>

                {props.clear && (
                    <button className={_styles.clearLink} onClick={props.clear}>
                        Clear
                    </button>
                )}
                <Button text='Close' onClick={handleClose} size={'s'} appearance={'lined'} />
            </div>
            <div className={cn(_styles.body, props.bodyClassName)}>{props.children}</div>
            {!props.hideSecondaryDismiss && (
                <div className={cn(_styles.footer, props.footerClassName)}>
                    <Button className={_styles.footerCloseButton} text='Show Results' onClick={handleClose} />
                </div>
            )}
        </div>
    );
};

export default FilterInterstitial;
